import React from 'react';
import Loader from './Loader.jsx';
import '../styles/pageLoader.css';

/**
 * Full-viewport centered loader for route/auth idle states.
 * Use Loader directly when embedding inside a layout (e.g. search waiting).
 */
const PageLoader = ({ message }) => (
  <div className="page-loader" role="status" aria-live="polite" aria-busy="true">
    <Loader />
    {message ? <p className="page-loader-message">{message}</p> : null}
  </div>
);

export default PageLoader;
